import { getDateString, getCurrentDateObj, getTomorrow, getNextWeekDateObj, getStartOfWeek, getEndOfWeek, getStartOfWeekend, getStartOfMonth, getEndOfMonth } from '../../../core/utils/date.util';
export default class TabsProvider {
    constructor() {
        this._todayDateString = getDateString(getCurrentDateObj());
        this._tomorrowDateString = getDateString(getTomorrow());
        this._startOfWeekDateString = getDateString(getStartOfWeek(this._todayDateString));
        this._endOfWeekDateString = getDateString(getEndOfWeek(this._todayDateString));
        this._startOfWeekendDateString = getDateString(getStartOfWeekend(this._todayDateString));
        this._endOfWeekendDateString = this._endOfWeekDateString;
        this._nextWeekDateString = getDateString(getNextWeekDateObj());
        this._startOfNextWeekDateString = getDateString(getStartOfWeek(this._nextWeekDateString));
        this._endOfNextWeekDateString = getDateString(getEndOfWeek(this._nextWeekDateString));
        this._startOfNextWeekendDateString = getDateString(getStartOfWeekend(this._nextWeekDateString));
        this._endOfNextWeekendDateString = this._endOfNextWeekDateString;
        this._startOfMonthDateString = getDateString(getStartOfMonth(this._todayDateString));
        this._endOfMonthDateString = getDateString(getEndOfMonth(this._todayDateString));
        this._tabOptions = [
            {
                label: 'Nejbližší',
                key: '',
                dateFrom: this._todayDateString,
                dateTo: '',
            },
            {
                label: 'Dnes',
                key: 'dnes',
                dateFrom: this._todayDateString,
                dateTo: this._todayDateString,
            },
            {
                label: 'Zítra',
                key: 'zitra',
                dateFrom: this._tomorrowDateString,
                dateTo: this._tomorrowDateString,
            },
            {
                label: 'Tento týden',
                key: 'tentoTyden',
                dateFrom: this._startOfWeekDateString,
                dateTo: this._endOfWeekDateString,
            },
            {
                label: 'Tento víkend',
                key: 'tentoVikend',
                dateFrom: this._startOfWeekendDateString,
                dateTo: this._endOfWeekendDateString,
            },
            {
                label: 'Příští týden',
                key: 'pristiTyden',
                dateFrom: this._startOfNextWeekDateString,
                dateTo: this._endOfNextWeekDateString,
            },
            {
                label: 'Příští víkend',
                key: 'pristiVikend',
                dateFrom: this._startOfNextWeekendDateString,
                dateTo: this._endOfNextWeekendDateString,
            },
            {
                label: 'Tento měsíc',
                key: 'tentoMesic',
                dateFrom: this._startOfMonthDateString,
                dateTo: this._endOfMonthDateString,
            },
        ];
    }
    getTabByKey(key) {
        return this._tabOptions.find((tab) => tab.key === key);
    }
    getTabPropertyByKey(key, property) {
        const tab = this._tabOptions.find((tab) => tab.key === key);
        if (!tab) {
            return undefined;
        }
        return tab[property];
    }
    get tabOptions() {
        return this._tabOptions;
    }
}
